 <template>
  <!-- you can rename class or id for this component, please put your comment what you need for styling needs -->

  <div :class="nameclass || 'emailDefaultClass'">
    <!-- for each component have default label and classname, 
    you can inherit when you call the component-->
    <label :id="idname || 'labeldefaultemail'">{{label}}</label>
    <b-form-input
      size="lg"
      v-bind="$attrs"
      type="email"
      v-on="$listeners"
      :value="value"
      @input="$emit('update', $event)"
      @change="validateEmail"
      @keypress="validateEmail"
      autocomplete="off"
      :style="{backgroundColor:value ? 'rgba(79, 208, 110,0.2)':'aliceblue'}"
    ></b-form-input>
    <p class="validation-message" v-if="isValid == false||nameclass['error register-input']==true">Please enter a valid email</p>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      isValid: null
    };
  },
  inheritAttrs: false,
  props: ["value", "label", "nameclass", "idname", "isEmailValid"],
  model: {
    prop: "value",
    event: "update"
  },
  methods: {
    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.value)) {
        this.isValid = true;
        this.$emit("validateEmail", true);
      } else if (this.value == "") {
        this.isValid = null;
        this.$emit("validateEmail", false);
      } else {
        this.isValid = false;
        this.$emit("validateEmail", false);
      }
    }
  },
  watch: {
    value: function(updated, old) {
      if (updated == "") {
        this.isValid = null;
      }
    }
  }
};
</script>